export default __webpack_public_path__ + "static/media/waiting.4c82ffc7.svg";